import React from "react"

import {
  AuthorContainer,
  AuthorImageContainer,
  AuthorImage,
  AuthorTextContainer,
  AuthorName,
  AuthorBio,
} from "./AuthorElements"

const Author = ({ img, alt, name, bio }) => {
  console.log(img, alt)
  return (
    <AuthorContainer>
      <AuthorImageContainer>
        <AuthorImage image={img} alt={alt} />
      </AuthorImageContainer>
      <AuthorTextContainer>
        <AuthorName>{name}</AuthorName>
        <AuthorBio>{bio}</AuthorBio>
      </AuthorTextContainer>
    </AuthorContainer>
  )
}

export default Author
